/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountTagKeyRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountTagKeyRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return ServiceAccountTagKeyRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountTagKeyRegexQueryOperator>): ServiceAccountTagKeyRegexQueryOperator {
        let obj = Object.assign(new ServiceAccountTagKeyRegexQueryOperator(), model);
        ServiceAccountTagKeyRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountTagKeyRegexQueryOperator>): ServiceAccountTagKeyRegexQueryOperator {
        if (!model) return null;
        return ServiceAccountTagKeyRegexQueryOperator.newInstance(<ServiceAccountTagKeyRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountTagKeyRegexQueryOperator) {
        if (!obj) return;

        models.ServiceAccountTagKeyRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountTagKeyRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountTagKeyRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.tag_key) {
            models.Regex.fixupPrototype(this.tag_key);
        }
    }

    /**
     * Include response that has the given tag key pattern
     */
    tag_key: models.Regex;

}
